import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PackageUserRole } from 'src/app/features/package-users';
import { PackageUserWithDisplayName } from 'src/app/features/package-users/util';

@Component({
  selector: 'app-add-participant',
  templateUrl: './add-participant.component.html',
  styleUrls: ['./add-participant.component.scss'],
  standalone: false,
})
export class AddParticipantComponent implements OnInit {
  @Input() isSelected = false;
  @Input() participant: PackageUserWithDisplayName;
  @Output() participantClicked = new EventEmitter();

  imageSources: Record<string, string> = {
    [PackageUserRole.WITNESS]: 'participant-witness',
    [PackageUserRole.SIGNINGAGENT]: 'participant-sa',
    default: 'participant-nonsa',
  };
  imageDescriptions: Record<string, string> = {
    [PackageUserRole.WITNESS]: 'Image of eyeball',
    default: 'Image of feather pen',
  };

  imageSrc: string;
  imageAltText: string;

  constructor() {}

  ngOnInit(): void {
    const userRoleCode =
      this.participant.userRoleCode === PackageUserRole.WITNESS
        ? this.participant.userRoleCode
        : 'default';
    this.imageSrc = this.imageSources[userRoleCode];
    this.imageAltText = this.imageDescriptions[userRoleCode];
  }

  onSelectParticipant() {
    this.participantClicked.emit();
  }

  getPackageUserRole(role: PackageUserRole) {
    const roles: Record<PackageUserRole, string> = {
      BORROWER: 'Borrower',
      SYSTEM: 'System',
      SIGNINGAGENT: 'Notary',
      NBTH: 'Non-Borrowing Title Holder',
      SELLER: 'Seller',
      SIGNER: 'Signer',
      WITNESS: 'Witness',
    };

    return roles[role];
  }
}
